import { render, staticRenderFns } from "./CaKpiCards.vue?vue&type=template&id=3a5248bc&scoped=true"
import script from "./CaKpiCards.vue?vue&type=script&lang=js"
export * from "./CaKpiCards.vue?vue&type=script&lang=js"
import style0 from "./CaKpiCards.vue?vue&type=style&index=0&id=3a5248bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5248bc",
  null
  
)

export default component.exports